var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.578,
    height: 27.75,
    viewBox: "327.211 601.75 31.578 27.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "alert-line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.299 602.5 14.289 24.75a1.5 1.5 0 0 1-1.299 2.25h-28.578a1.5 1.5 0 0 1-1.299-2.25l14.289-24.75a1.5 1.5 0 0 1 2.598 0Zm-12.99 24h23.382L343 606.25l-11.691 20.25ZM341.5 622h3v3h-3v-3Zm0-10.5h3v7.5h-3v-7.5Z",
    fill: "#541690",
    fillRule: "evenodd",
    "data-name": "Path 187"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLine);
export default __webpack_public_path__ + "static/media/alert-line.7de2bede.svg";
export { ForwardRef as ReactComponent };